import { useQuery } from "@apollo/client";
import { Box, Text } from "grommet";
import { useEffect, useMemo, useState } from "react";
import { animated, useSpring } from "react-spring";
import { GET_LATEST_DENY_WAR } from "../../queries/user_queries";
import Loading from "../Loading";
import { rankItemTheme } from "../rankItemTheme";
import "../style.css";

// interface Props {
//   title: string;
//   color: string;
//   amount: number;
//   requiredTokens: number;
// }
type Props = {
  shouldAutoHide?: boolean;
};
const DenyWarBar = ({ shouldAutoHide = false }: Props) => {
  const [hidden, setHidden] = useState(false);
  const { loading, error, data, startPolling, stopPolling } =
    useQuery(GET_LATEST_DENY_WAR);

  useEffect(() => {
    if (shouldAutoHide) {
      startPolling(1000);
    } else {
      startPolling(10000);
    }

    return () => stopPolling();
  }, []);

  const gradientTwo = useMemo(() => {
    const theme = rankItemTheme;
    const { colorOne, colorTwo, colorThree } = theme;
    return `linear-gradient(-45deg, ${colorOne}, ${colorTwo}, ${colorThree})`;
  }, []);

  const [denies, undenies, max] = useMemo(() => {
    if (data?.getLatestDenyWar) {
      const { denies, undenies, winAmount } = data.getLatestDenyWar;
      const max = winAmount;
      return [denies, undenies, max];
    }
    return [0, 0, 10];
  }, [data]);

  useEffect(() => {
    if (shouldAutoHide) {
      setHidden(false);
      setTimeout(() => {
        setHidden(true);
      }, 4000);
    }
  }, [denies, undenies, max]);
  const { val: denyVal } = useSpring({
    val: (denies / max / 2) * 100 + "%",
    from: { val: "0%" },
    config: {
      mass: 10,
      friction: 20,
      tension: 50,
    },
  });

  const { val: unDenyVal } = useSpring({
    val: (undenies / max / 2) * 100 + "%",
    from: { val: "0%" },
    config: {
      mass: 10,
      friction: 20,
      tension: 50,
    },
  });

  if (!data || !data.getLatestDenyWar) {
    return <Loading />;
  }

  return (
    <Box animation={hidden ? "fadeOut" : "fadeIn"} width={"full"}>
      <Box flex direction="row" justify="around" width={"full"}>
        <Box width={"small"} align="center">
          <Text color={"status-ok"}>Undeny</Text>
        </Box>

        <Box width={"small"} align="center">
          <Text color={"status-error"}>Deny</Text>
        </Box>
      </Box>
      <Box
        style={{
          background: gradientTwo,
          backgroundSize: "600% 600%",
          WebkitAnimation: "Gradient 10s ease infinite",
          MozAnimation: "Gradient 10s ease infinite",
          animation: "Gradient 10s ease infinite",
          borderRadius: 12,
          fontFamily: "Orbitron",
          backgroundPosition: 0,
          flexDirection: "row",
        }}
        justify="between"
      >
        <Box
          style={{ position: "absolute" }}
          justify="center"
          alignSelf="center"
          width={"full"}
          align="center"
          alignContent="center"
        >
          <Text color={"dark-1"} size="large" weight={"bolder"}>
            |
          </Text>
        </Box>
        <animated.div
          style={{
            width: unDenyVal.to((v) => v),
            backgroundColor: "#6FFFB0",
            height: "20px",
            borderRadius: 12,
            color: "black",
          }}
        ></animated.div>
        <animated.div
          style={{
            width: denyVal.to((v) => v),
            backgroundColor: "red",
            height: "20px",
            borderRadius: 12,
            alignSelf: "end",
          }}
        ></animated.div>
      </Box>
      <Box flex direction="row" justify="around">
        <Box width={"small"} align="center">
          <Text color={"status-ok"}>{undenies}</Text>
        </Box>
        <Box width={"medium"} align="center">
          <Text color={"light-1"}>{max}</Text>
        </Box>
        <Box width={"small"} align="center">
          <Text color={"status-critical"}>{denies}</Text>
        </Box>
      </Box>
    </Box>
  );
};

export default DenyWarBar;
